import { DA_DOCUMENT_TRACKING_MENU_ITEM_NAME } from '../../config/featureFlags';

// Accommodation Services is a display-only grouping: there is no CAMS row for it.
// The existing parent row grants the student page; the separate Manage row grants
// approval. Keep both checks tied to the exact CAMS metadata, not a general bypass.
export const ACCOMMODATION_DISPLAY = 'Student Life-Accommodation Services Display';
export const ACCOMMODATION_PARENT = 'Student Life-Disability Accommodations';
export const ACCOMMODATION_MANAGE = 'Student Life-Disability Accommodations-Manage';

// True when the user holds an active grant on the exact accommodation CAMS row.
const hasGrant = (rows, name, parentorder) => (rows || []).some(row =>
    row.menuItemName?.trim() === name && row.menuAccess > 0 &&
    row.moduleorder === 12 && row.menulevel === 5 && row.parentorder === parentorder
);

export const hasAccommodationAccess = (item, access) => {
    const hasParent = hasGrant(access.nestedParentLevel, ACCOMMODATION_PARENT, 0);
    // Document Tracking has its own CAMS row, so it is granted without the parent row,
    // and that grant alone is enough to show the grouping.
    const hasDocumentTracking = hasGrant(access.subNestedParentLevel, DA_DOCUMENT_TRACKING_MENU_ITEM_NAME, 3);
    if (item.moduleorder !== 12 || item.menulevel !== 5) return false;
    if (item.menuItemName === ACCOMMODATION_DISPLAY) {
        return (hasParent || hasDocumentTracking) && item.displayOnly === true && item.parentorder === 0 && !item.url;
    }
    if (item.menuItemName === ACCOMMODATION_PARENT) return hasParent && item.parentorder === 0 && item.url === '/student-life/disability-accommodations';
    if (item.menuItemName === ACCOMMODATION_MANAGE) {
        return hasParent && item.parentorder === 1 && item.url === '/student-life/disability-accommodations/staff' &&
            hasGrant(access.subNestedParentLevel, ACCOMMODATION_MANAGE, 1);
    }
    if (item.menuItemName === DA_DOCUMENT_TRACKING_MENU_ITEM_NAME) {
        return hasDocumentTracking && item.parentorder === 3 && item.url === '/student-life/student-search';
    }
    return false;
};
